import React from 'react';
import { Alert, AlertProps } from 'react-bootstrap';

interface FormAlertProps extends Omit<AlertProps, 'show'> {
  message?: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  dismissible?: boolean;
  onDismiss?: () => void;
}

export const FormAlert: React.FC<FormAlertProps> = ({
  message,
  variant = 'danger',
  dismissible = true,
  onDismiss,
  children,
  className = '',
  ...props
}) => {
  if (!message && !children) {
    return null;
  }

  return (
    <Alert
      variant={variant}
      dismissible={dismissible}
      onClose={onDismiss}
      className={`mb-3 ${className}`}
      {...props}
    >
      {message || children}
    </Alert>
  );
}; 
